module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.klass.container
  }, [_vm._l((_vm.normalizeTagItems), function(item, index) {
    return [_c('typing', {
      attrs: {
        "index": index,
        "typing": index === _vm.typingIndex,
        "handle-insert": _vm.insertTag,
        "handle-remove": _vm.removeTag,
        "active-other": _vm.activeOther
      },
      on: {
        "click": function($event) {
          _vm.focus(index)
        },
        "blur": function($event) {
          _vm.blur(index)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.length && _vm.showPlaceholder),
        expression: "index === length && showPlaceholder"
      }],
      class: _vm.klass.placeholder
    }, [_vm._v(_vm._s(_vm.placeholder))])]), _vm._v(" "), (index !== _vm.length) ? _c('tag', {
      attrs: {
        "text": item.text,
        "remove": _vm.getRemoveHandle(item, index),
        "invalid": item.invalid
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a2297bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/input.vue
// module id = 22
// module chunks = 0